module.exports = __webpack_public_path__ + "img/crear_contrasena_large.0ce0fdeb.svg";